import { MSG_NAME_TO_IFRAME, VisitorVariationUpdateParam } from '../type';
export function sendMessageToIframe(data) {
    if (!window?.frames?.ABTastyQaAssistant) {
        return;
    }
    window.frames.ABTastyQaAssistant.postMessage(data, '*');
}
export function sendVisitorAllocatedVariations(visitorVariationState) {
    if (!visitorVariationState?.visitorVariations) {
        return;
    }
    sendMessageToIframe({
        name: MSG_NAME_TO_IFRAME.FsUpdateVisitorAllocatedVariation,
        value: visitorVariationState.visitorVariations,
        visitorData: visitorVariationState.visitorData,
        sdkInfo: visitorVariationState.sdkInfo
    });
}
export function sendVisitorExposedVariations(visitorVariationState) {
    if (!visitorVariationState?.exposedVariations) {
        return;
    }
    const navigationDetected = visitorVariationState.navigationDetected;
    if (visitorVariationState.navigationDetected) {
        visitorVariationState.navigationDetected = false;
    }
    sendMessageToIframe({
        name: MSG_NAME_TO_IFRAME.FsVisitorExposedVariation,
        value: visitorVariationState.exposedVariations,
        param: navigationDetected ? VisitorVariationUpdateParam.NewNavigation : undefined
    });
}
export function sendFsHitToQA(hit) {
    sendMessageToIframe({
        name: MSG_NAME_TO_IFRAME.FsHIT,
        value: hit.map(item => {
            return {
                ...item,
                timestamp: Date.now() - item.qt
            };
        })
    });
}
